import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export default function AdminContacts() {
    const navigate = useNavigate();
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const fetchContacts = useCallback(async () => {
        try {
            setLoading(true);
            const res = await axiosInstance.get("/api/contacts/admin/all");
            // Handle different response formats if necessary
            const data = Array.isArray(res.data) ? res.data : (res.data?.contacts || []);
            setContacts(data);
        } catch (err) {
            setError("Failed to fetch contacts.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchContacts();
    }, [fetchContacts]);

    const markAsRead = async (id) => {
        try {
            await axiosInstance.patch(`/api/contacts/admin/${id}/read`);
            setContacts(prev => prev.map(c => c.id === id ? { ...c, isRead: true } : c));
        } catch (err) {
            alert("Failed to mark as read.");
            console.error(err);
        }
    };

    const goBack = () => navigate("/admin/dashboard");

    if (loading) return <div style={{ padding: 20 }}>Loading contacts...</div>;

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2 style={{ margin: 0 }}>Contact Inquiries</h2>
                <button onClick={goBack} style={styles.dashboardBtn}>← Dashboard</button>
            </div>

            {error && <div style={styles.error}>{error}</div>}

            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>Date</th>
                            <th style={styles.th}>Name</th>
                            <th style={styles.th}>Phone</th>
                            <th style={{ ...styles.th, width: '40%' }}>Message</th>
                            <th style={styles.th}>Status</th>
                            <th style={styles.th}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contacts.length === 0 ? (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>No inquiries found.</td>
                            </tr>
                        ) : (
                            contacts.map((c) => (
                                <tr key={c.id} style={{
                                    ...styles.tr,
                                    background: !c.isRead ? '#fff9f9' : '#fff',
                                    borderLeft: !c.isRead ? '4px solid #ff4d4f' : '4px solid transparent'
                                }}>
                                    <td style={styles.td}>{new Date(c.createdAt).toLocaleDateString()}</td>
                                    <td style={styles.td}><b>{c.name}</b></td>
                                    <td style={styles.td}>{c.phone}</td>
                                    <td style={styles.td}>
                                        <div style={styles.messageBox}>{c.message}</div>
                                    </td>
                                    <td style={styles.td}>
                                        {c.isRead ? (
                                            <span style={styles.readBadge}>Read</span>
                                        ) : (
                                            <span style={styles.unreadBadge}>New</span>
                                        )}
                                    </td>
                                    <td style={styles.td}>
                                        {!c.isRead && (
                                            <button onClick={() => markAsRead(c.id)} style={styles.actionBtn}>
                                                Mark as Read
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const styles = {
    container: { padding: "24px", background: "#fdfdfd", minHeight: "100vh" },
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
    dashboardBtn: { padding: "8px 16px", background: "#fff", color: "#111", border: "1px solid #ddd", borderRadius: 8, cursor: "pointer", fontWeight: 700 },
    error: { color: "red", background: "#fee2e2", padding: 10, borderRadius: 8, marginBottom: 15 },
    tableWrapper: { background: "#fff", borderRadius: 16, border: "1px solid #eee", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.03)" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: 14 },
    th: { padding: "16px", background: "#f8f9fa", textAlign: "left", fontWeight: 700, borderBottom: "1px solid #eee", color: "#666" },
    tr: { transition: "0.2s" },
    td: { padding: "16px", borderBottom: "1px solid #eee", verticalAlign: "top" },
    messageBox: { whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: 100, overflowY: "auto", fontSize: 13, color: "#444" },
    unreadBadge: { background: "#ff4d4f", color: "#fff", padding: "4px 10px", borderRadius: 99, fontSize: 11, fontWeight: 900, textTransform: "uppercase" },
    readBadge: { background: "#52c41a", color: "#fff", padding: "4px 10px", borderRadius: 99, fontSize: 11, fontWeight: 900, textTransform: "uppercase" },
    actionBtn: { padding: "6px 12px", background: "#1ECCB0", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 12 },
};
